import { MessageSquare, MapPin, Clock } from "lucide-react";
import LegalPageLayout from "@/components/landing/LegalPageLayout";

const contactMethods = [
  {
    icon: MessageSquare,
    title: "Live Chat",
    description: "For immediate assistance with your account",
    detail: "Available in the Trust Wallet app",
    response: "Average wait: 2 minutes",
  },
  {
    icon: Clock,
    title: "Priority Support",
    description: "Dedicated line for Metal card holders",
    detail: "Available in the Trust Wallet app",
    response: "Response within 1 hour, 24/7",
  },
];

const offices = [
  {
    city: "Toronto (HQ)",
    address: "200 Bay Street, Suite 3600\nToronto, ON M5J 2J1\nCanada",
  },
  {
    city: "Amsterdam",
    address: "Keizersgracht 482\n1017 EG Amsterdam\nNetherlands",
  },
  {
    city: "London",
    address: "One Canada Square, Level 42\nCanary Wharf\nLondon E14 5AB, UK",
  },
  {
    city: "Hong Kong",
    address: "Two IFC, 88 Queensway\nCentral\nHong Kong",
  },
];

const ContactUs = () => (
  <LegalPageLayout title="Contact Us" lastUpdated="January 15, 2026">
    <p className="text-lg">
      We're here to help. Choose the best way to reach our team based on your needs.
    </p>

    <section>
      <h2>Support Channels</h2>
      <div className="!mt-6 grid gap-4 sm:grid-cols-1">
        {contactMethods.map((method) => {
          const Icon = method.icon;
          return (
            <div key={method.title} className="rounded-2xl border border-border/60 bg-card/80 p-6">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary text-primary">
                  <Icon className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="!mt-0 text-lg font-bold">{method.title}</h3>
                  <p className="!mt-1 text-muted-foreground">{method.description}</p>
                  <p className="!mt-2 font-semibold text-foreground">{method.detail}</p>
                  <p className="!mt-1 text-sm text-primary">{method.response}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>

    <section>
      <h2>Office Locations</h2>
      <div className="!mt-6 grid gap-4 sm:grid-cols-2">
        {offices.map((office) => (
          <div key={office.city} className="rounded-2xl border border-border/60 bg-card/80 p-6">
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-primary" />
              <h3 className="!mt-0 font-bold">{office.city}</h3>
            </div>
            <p className="!mt-2 whitespace-pre-line text-sm">{office.address}</p>
          </div>
        ))}
      </div>
    </section>

    <section>
      <h2>Report Security Issues</h2>
      <p>
        If you've discovered a security vulnerability, please report it responsibly through the Trust Wallet app. We operate a bug bounty program and reward verified security reports. Please do not disclose vulnerabilities publicly before we've had a chance to investigate and patch them.
      </p>
    </section>
  </LegalPageLayout>
);

export default ContactUs;
